module.exports = __webpack_public_path__ + "6595ea1134907de25d141151f7152455.svg";